import { RouteConfig } from 'vue-router';
import { requireProvider, requireSeeker } from '../guards/authGuards';

import Adventures from '@/apps/adventures/Adventures.vue';
import Dashboard from '@/apps/adventures/dashboard/Dashboard.vue';
import Create from '@/apps/adventures/create/Create.vue';
import Edit from '@/apps/adventures/edit/Edit.vue';
import ViewAdventure from '@/apps/adventures/details/ViewAdventure.vue';
import Search from '@/apps/adventures/search/Search.vue';

// Adventure form components
import Category from '@/apps/adventures/forms/Category.vue';
import AgeRange from '@/apps/adventures/forms/AgeRange.vue';
import Description from '@/apps/adventures/forms/Description.vue';
import Duration from '@/apps/adventures/forms/Duration.vue';
import Supplies from '@/apps/adventures/forms/Supplies.vue';
import Rate from '@/apps/adventures/forms/Rate.vue';
import Passion from '@/apps/adventures/forms/Passion.vue';
import Photo from '@/apps/adventures/forms/Photo.vue';
import Title from '@/apps/adventures/forms/Title.vue';
import Availability from '@/apps/adventures/forms/Availability.vue';
import AvailabilityDetails from '@/apps/adventures/forms/availability/AvailabilityDetails.vue';
import AvailabilityEdit from '@/apps/adventures/forms/availability/AvailabilityEdit.vue';
import Review from '@/apps/adventures/create/review/Review.vue';

const adventuresRoutes: RouteConfig[] = [
  {
    path: '/adventures',
    component: Adventures,
    children: [
      {
        path: '',
        name: 'AdventuresDashboard',
        component: Dashboard,
        beforeEnter: requireProvider,
      },
      {
        path: 'search*',
        name: 'SearchAdventures',
        component: Search,
        beforeEnter: requireSeeker,
      },
      {
        path: 'details/:stateCode?/:city?/:adventureId',
        name: 'ViewAdventure',
        component: ViewAdventure,
      },
      {
        path: ':adventureId/edit',
        name: 'EditAdventure',
        component: Edit,
        beforeEnter: requireProvider,
      },
      {
        path: 'new',
        name: 'CreateAdventure',
        component: Create,
        redirect: '/adventures/new/category',
        beforeEnter: requireProvider,
        children: [
          {
            path: 'category',
            name: 'Category',
            meta: { step: 1, trackCreateFlow: true },
            component: Category,
            alias: '/adventures/:adventureId/edit/category',
          },
          {
            path: 'age_range',
            name: 'Age',
            meta: { step: 2, trackCreateFlow: true },
            component: AgeRange,
            alias: '/adventures/:adventureId/edit/age_range',
          },
          {
            path: 'description',
            name: 'Description',
            meta: { step: 3, trackCreateFlow: true },
            component: Description,
            alias: '/adventures/:adventureId/edit/description',
          },
          {
            path: 'passion',
            name: 'Promote',
            meta: { step: 4, trackCreateFlow: true },
            component: Passion,
            alias: '/adventures/:adventureId/edit/passion',
          },
          {
            path: 'title',
            name: 'Title',
            meta: { step: 5, trackCreateFlow: true },
            component: Title,
            alias: '/adventures/:adventureId/edit/title',
          },
          {
            path: 'duration',
            name: 'Duration',
            meta: { step: 6, trackCreateFlow: true },
            component: Duration,
            alias: '/adventures/:adventureId/edit/duration',
          },
          {
            path: 'supplies',
            name: 'Supplies',
            meta: { step: 7, trackCreateFlow: true },
            component: Supplies,
            alias: '/adventures/:adventureId/edit/supplies',
          },
          {
            path: 'rate',
            name: 'Rate',
            meta: { step: 8, trackCreateFlow: true },
            component: Rate,
            alias: '/adventures/:adventureId/edit/rate',
          },
          {
            path: 'photo',
            name: 'Photo',
            meta: { step: 9, trackCreateFlow: true },
            component: Photo,
            alias: '/adventures/:adventureId/edit/photo',
          },
          {
            path: 'availability',
            component: Availability,
            meta: { step: 10 },
            children: [
              {
                path: '',
                name: 'AdventuresAvailability',
                component: AvailabilityDetails,
                meta: { trackCreateFlow: true },
              },
              {
                path: 'edit',
                name: 'AvailabilityEdit',
                component: AvailabilityEdit,
                alias: '/adventures/:adventureId/edit/availability/edit',
              },
            ],
          },
          {
            path: 'review',
            name: 'Review',
            meta: { step: 11, trackCreateFlow: true },
            component: Review,
          },
        ],
      },
    ],
  },
];

export default adventuresRoutes;
